import api from "../api";

const register = async (name, account, password, email) => {
  const requestData = {
    chName: name, // 用戶名稱(必填)
    coin: 0, // 一律送0(必填)
    email: email, // 信箱(必填)
    account: account, // 帳號(必填)
    password: password, // 密碼(必填)
    birthday: "1900-01-01",
    gender: "male",
    phone: account, // 手機號碼(必填)
  };

  try {

    const response = await api.post(
      process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app-users/register",
      requestData
    );

    // Check if the status code indicates success (typically 200 or 201)
    if (response.status === 200 || response.status === 201) {

      return response.data; // Optionally return the response data
    } else {
      console.error("Registration failed with status:", response.status);
      return null; // Return null or handle as necessary
    }
  } catch (error) {
    console.error("There was a problem with the axios operation:", error);
    throw error; // Rethrow the error so it can be handled elsewhere
  }
};

export default register;
